import React from 'react';

import styled from 'styled-components';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  position: relative;
  margin: 30px;
`;

const TableBody = styled.tbody`
  display: block;
  max-height: 173.5px;
  overflow-y: auto;
`;

const TableRow = styled.tr`
  display: table;
  width: 100%;
  table-layout: fixed;
  border-bottom: 1px solid #ddd;
`;

const Table = styled.table`
  width: 730px;
  border-collapse: collapse;
  border: 1px solid #ccc;
  display: block;
`;

const TableHeader = styled.div`
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid #ddd;
  justify-content: center;
  height: 60px;
  background-color: var(--gray-medium);
`;

const ExpandContainer = styled.div`
  padding-left: 12px;
  padding-right: 6px;
  height: 24px;
  width: 24px;
  cursor: pointer;
`;

const Title = styled.div`
  font-weight: 900;
  display: flex;
`;

const CommunitiesCount = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
  padding-left: 40px;
`;

const TableCell = styled.td`
  height: 55px;
  padding-left: 40px;
  padding-right: 10px;
`;

const TableCellContent = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const CommunityDetails = styled.div`
  display: flex;
  flex-direction: column;
`;

const CommunityName = styled.div`
  font-size: 14px;
  font-weight: 900;
`;

const CompanyName = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
`;

const Alert = styled.div`
  font-weight: 900;
  color: var(--negative-orange);
`;

type Props = {
  notificationRecipients: any[];
};

const CommunityIncentiveNotificationRecipients = ({ notificationRecipients }: Props) => {
  const [expanded, setExpanded] = React.useState<boolean>(true);

  const notificationRecipentEnabledCount = notificationRecipients.filter((x) => x.incentive_email_notifications).length;
  const communitiesCountText =
    notificationRecipients?.length > 0
      ? `${notificationRecipentEnabledCount}/${notificationRecipients.length} Communities`
      : 'No notification recipients';

  const toggleExpanded = () => {
    setExpanded(!expanded);
  };

  return (
    <Container>
      <Table>
        <TableHeader>
          <Title>
            <ExpandContainer onClick={toggleExpanded}>
              <img
                src={expanded ? '/icons/expand-more.svg' : '/icons/chevron-right.svg'}
                style={{ width: '24px', height: '24px' }}
              />
            </ExpandContainer>
            <span>Notification Recipients</span>
          </Title>
          <CommunitiesCount>{communitiesCountText}</CommunitiesCount>
        </TableHeader>
        {expanded && (
          <TableBody className="mini-scroll">
            {notificationRecipients.map((notificationRecipient, index) => (
              <TableRow key={index}>
                <TableCell>
                  <TableCellContent>
                    <CommunityDetails>
                      <CommunityName>{notificationRecipient.community_name}</CommunityName>
                      <CompanyName>{notificationRecipient.company_name}</CompanyName>
                    </CommunityDetails>
                    <Alert>
                      {!notificationRecipient.incentive_email_notifications ? 'No notification recipients' : ''}
                    </Alert>
                  </TableCellContent>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
    </Container>
  );
};

export default CommunityIncentiveNotificationRecipients;
